import React from 'react';
import {shallowEqual} from 'react-redux';
import { IUserSession } from 'common';
import SimulationControls from './SimulationControls';
import { UpdateRevisionDialog } from './RevisionSelector';
import {PublishIcon, ShareIcon, Spinner} from '../Iconset';
import Button from '../layout/Button';
import PublishScenarioDialog from '../publishing/PublishScenarioDialog';
import ModalManager from '../layout/ModalManager';
import ScenarioShareDialog from '../ScenarioShareDialog';
import { LayoutOrientations} from '../../globals';
import Panel from '../layout/Panel';
import {TooltipKeys} from '../tooltips/TooltipKeys';
import {useTypedSelector} from '../../state/hooks';
import config from '../../config';
import { ProjectStates } from '../../interfaces/ProjectStates';
import store from '../../state/store';


ScenarioControls.onPublish = function ()
{
	ModalManager.addModal({
		content: <PublishScenarioDialog />
	});
}

ScenarioControls.onShare = function ()
{
	ModalManager.addModal({
		content: <ScenarioShareDialog />
	});
}

ScenarioControls.onNewRevision = function ()
{
	ModalManager.addModal({
		content: <UpdateRevisionDialog newRevision={true} />
	});
}

export default function ScenarioControls(props)
{
	const sessionInfo = useTypedSelector<IUserSession | null>(state => state.userModule.sessionInfo, shallowEqual);
	const isViewOnlyMode = useTypedSelector<boolean>(state => state.applicationModule.isViewOnlyMode, shallowEqual);
	const projectState = useTypedSelector<ProjectStates>(state => state.scenarioModule.projectState, shallowEqual);
	const isPublishInProgress = useTypedSelector(state => state.applicationModule.isPublishInProgress, shallowEqual);
	const loadedScenario = useTypedSelector(state => state.scenarioModule.scenarioId, shallowEqual);
	const scenarioInfo = useTypedSelector(state => state.scenarioModule.elementData[loadedScenario!]);
	if(!sessionInfo) return null;
	const standaloneMode = sessionInfo.mode === 'standalone';
	
	return (
		<Panel id="scenarioControlsRoot"
			orientation={LayoutOrientations.Horizontal}
			expand={0}
		>
			{
				standaloneMode || (isViewOnlyMode && !(store.getState().scenarioModule.permissions.canManage && projectState !== ProjectStates.Archived)) ? null :
					<Button data-name={"publish-scenario-button"}
						className={"scenarioControlButton"}
						label="Publish"
						iconRenderer={isPublishInProgress ? <Spinner size={16} /> : <PublishIcon />}
						onClick={ScenarioControls.onPublish}
						tooltip={TooltipKeys.ScenarioPublish}
						disabled={isPublishInProgress}
					/>
			}
			{
				isViewOnlyMode ? null :
					<SimulationControls />
			}
			{
				store.getState().scenarioModule.permissions.canManage ? 
					<Button data-name={"share-scenario-button"}
						className={"scenarioControlButton small"}
						//label="Share"
						iconRenderer={<ShareIcon />}
						onClick={ScenarioControls.onShare}
						tooltip={TooltipKeys.ScenarioShare}
					/> : null
			}
			{
				
				!config.USERFLOW_ENABLED ? null :
					<Button id={"userflow-placeholder"}
						data-name={"placeholder-userflow-menu"}
						className={"scenarioControlButton small"}
						style={{ backgroundColor: "#111111" }}
						data-tooltip={TooltipKeys.HelpAndResources}
					/>
			}

		</Panel>
	);
}

